import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ConfigurableDialog, DialogModule, DialogService } from '@proget-shared/dialog';
import { TranslateModule } from '@proget-shared/translate';

@Component({
  selector: 'lib-generate-qr-code',
  templateUrl: './generate-qr-code.component.html',
  styleUrls: ['./generate-qr-code.component.scss'],
  imports: [
    DialogModule,
    TranslateModule,
  ],
})
export class GenerateQrCodeComponent implements ConfigurableDialog {
  protected qrCode: SafeUrl = '';

  private readonly dialog = inject(DialogService);
  private readonly domSanitizer = inject(DomSanitizer);

  onConfiguration({ qrCode }: { qrCode: string }): void {
    this.qrCode = this.domSanitizer.bypassSecurityTrustResourceUrl(qrCode);
  }

  protected close(): void {
    this.dialog.close(this);
  }
}
